import React, { Fragment, useMemo, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Tooltip, Select, Drawer,
} from 'antd';
import { QUANTITY } from '@Apis/constants';
import {
  CaretRightFilled,
  CloseOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import H3FormInput from '@Uilib/h3FormInput';
import ProductCategoryLabel from '@Components/Common/ProductCategoryLabel';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import PRZButton from '../../../../../Common/UI/PRZButton';
import HideValue from '../../../../../Common/RestrictedAccess/HideValue';
import ProductFilterV2 from '../../../../../Common/ProductFilterV2';
import './style.scss';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const NewRawMaterial = (props) => {
  const {
    data, cfRMLine, customLineInputChange, formSubmitted, visibleColumns, selectedTenant, user, priceMasking, handleMultiProductChange, loading, enableAdvanceSearch, finishedGoods, bomLinesArray, updateData, tenantDepartmentId, handleProductChange, handleProductChangeValue, bomLines, addNewRow,
  } = props;
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const disableAddNewRMButton = useMemo(() => !!bomLinesArray?.find((item) => !(item?.product_sku_id || item?.tenant_product_info?.tenant_product_id)), [bomLinesArray]);

  const getColumns = (isChild) => {
    const { trackWastage, addNewRow } = props;
    const columns = [
      {
        title: '#',
        fixed: 'left',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        visible: true,
        render: (record) => ({
          props: {
            style: { backgroundColor: !record?.parent_bom_id ? '#ABE09835' : 'white' },
          },
          children: (
            <Fragment>
              {!record?.parent_bom_id
                ? (
                  <div className="rm-table__fg-name" style={{ display: 'flex', alignItems: 'center' }}>
                    <div>
                      {record?.tenant_product_info?.alias_name}
                      {' '}
                      <CaretRightFilled />
                    </div>
                    <PRZButton
                      className={disableAddNewRMButton ? 'disable-add-rm-button' : ''}
                      buttonStyle={{ borderRadius: '4px', width: 'fit-content' }}
                      type="ghost"
                      size="small"
                      onClick={() => {
                        addNewRow({ parentData: record });
                      }}
                      disabled={disableAddNewRMButton}
                    >
                      <FontAwesomeIcon icon={faCirclePlus} color="#74C0FC" />
                      &nbsp;
                      <span style={{ fontSize: '11px' }}>Add RM</span>
                    </PRZButton>
                  </div>
                )
                : (
                  <div style={{ whiteSpace: 'nowrap', minWidth: '40px', paddingLeft: '8px' }}>
                    {`${record?.parentSqn ? `${record?.parentSqn}.` : ''}${record?.sqn}`}
                  </div>
                )}
            </Fragment>
          ),
        }),
        width: '40px',
      },
      {
        title: 'Product',
        width: '240px',
        fixed: 'left',
        render: (text, record) => {
          const {
            handleProductChangeValue,
            handleProductChange,
            formSubmitted,
            addNewRow,
            tenantDepartmentId,
            data,
            excludedProducts,
            getExcludedProduct,
          } = props;
          return (
            <div className="mo-rw-table__product-name">

              <React.Fragment>
                <div className="flex-align-space-between">
                  {record?.product_sku_id ? (
                    <React.Fragment>
                      {isChild
                        ? (
                          <div style={{ width: '100%' }}>
                            <Link to={`/inventory/product/view/${record?.product_info?.product_sku_id}`} target="_blank">
                              {`#${record?.product_info?.internal_sku_code}`}
                            </Link>
                            <div style={{
                              display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
                            }}
                            >
                              <div>
                                {`${record?.product_info?.ref_product_code ? `${record?.product_info?.ref_product_code} - ` : ''}${record?.product_info?.product_sku_name}`?.trim()}
                              </div>
                              <PRZButton
                                className={disableAddNewRMButton ? 'disable-add-rm-button' : ''}
                                buttonStyle={{ borderRadius: '4px' }}
                                type="ghost"
                                size="small"
                                onClick={() => {
                                  addNewRow({
                                    parentData: record,
                                    isChildBom: true,
                                    callback: (rowKey) => {
                                      setExpandedRowKeys((prev) => (prev.includes(rowKey) ? prev : [...prev, rowKey]));
                                    },
                                  });
                                }}
                                disabled={disableAddNewRMButton}
                              >
                                <FontAwesomeIcon icon={faCirclePlus} color="#74C0FC" />
                                &nbsp;
                                <span style={{ fontSize: '11px' }}>Add RM</span>
                                {/* + Add RM isChild */}
                              </PRZButton>
                            </div>
                          </div>
                        )
                        : (
                          <React.Fragment>
                            {
                              record?.parent_bom_id ? (
                                <div style={{ width: '100%' }}>
                                  <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`} target="_blank">
                                    {`#${record?.tenant_product_info?.internal_sku_code}`}
                                  </Link>
                                  <div style={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
                                  }}
                                  >
                                    <div>
                                      {`${record?.tenant_product_info?.ref_product_code ? `${record?.tenant_product_info?.ref_product_code} - ` : ''}${record?.productSkuName}`?.trim()}
                                    </div>
                                    <PRZButton
                                      className={disableAddNewRMButton ? 'disable-add-rm-button' : ''}
                                      buttonStyle={{ borderRadius: '4px' }}
                                      type="ghost"
                                      size="small"
                                      onClick={() => {
                                        addNewRow({
                                          parentData: record,
                                          isChildBom: true,
                                          callback: (rowKey) => {
                                            setExpandedRowKeys((prev) => (prev.includes(rowKey) ? prev : [...prev, rowKey]));
                                          },
                                        });
                                      }}
                                      disabled={disableAddNewRMButton}
                                    >
                                      <FontAwesomeIcon icon={faCirclePlus} color="#74C0FC" />
                                      &nbsp;
                                      <span style={{ fontSize: '11px' }}>Add RM</span>
                                      {/* + Add RM parentBom */}
                                    </PRZButton>
                                  </div>
                                </div>
                              ) : (
                                <div style={{ width: '100%' }}>
                                  <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`} target="_blank">
                                    {`#${record?.tenant_product_info?.internal_sku_code}`}
                                  </Link>
                                  <div style={{
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
                                  }}
                                  >
                                    <div>
                                      {`${record?.tenant_product_info?.ref_product_code ? `${record?.tenant_product_info?.ref_product_code} - ` : ''}${record?.tenant_product_info?.alias_name}`?.trim()}
                                    </div>
                                    <PRZButton
                                      className={disableAddNewRMButton ? 'disable-add-rm-button' : ''}
                                      buttonStyle={{ borderRadius: '4px' }}
                                      type="ghost"
                                      size="small"
                                      onClick={() => {
                                        addNewRow({ parentData: record });
                                      }}
                                      disabled={disableAddNewRMButton}
                                    >
                                      <FontAwesomeIcon icon={faCirclePlus} color="#74C0FC" />
                                      &nbsp;
                                      <span style={{ fontSize: '11px' }}>Add RM</span>
                                      {/* + Add RM Else */}
                                    </PRZButton>
                                  </div>
                                </div>
                              )
                            }
                          </React.Fragment>
                        )}
                    </React.Fragment>
                  ) : (
                    <div style={{ width: '100%' }}>
                      <ProductFilterV2
                        record={record}
                        productTypes={['STORABLE', 'NON_STORABLE']}
                        handleProductChangeValue={handleProductChangeValue}
                        handleProductChange={(tenantSku, key, productData) => handleProductChange({
                          tenantSku, key, productData, currentRow: record,
                        })}
                        required
                        showError={formSubmitted && !record.productSkuName}
                        excludedProducts={record?.parent_bom_id ? getExcludedProduct(record?.fg_tenant_product_id, record?.parent_bom_id, record?.bom_id) : excludedProducts}
                        tenantDepartmentId={tenantDepartmentId}
                        disabled={record?.product_sku_id}
                        showClear={!!record?.product_sku_id}
                        selectedTenant={selectedTenant}
                        enableAdvanceSearch={enableAdvanceSearch}
                        handleMultiProductChange={(tenantSku, key, productData, callback) => handleMultiProductChange(tenantSku, key, productData, callback, record)}
                        loading={loading}
                      />
                    </div>
                  )}

                  {record?.product_sku_id && !record?.tenant_product_info?.tenant_product_id ? (
                    <div style={{ pointerEvents: 'all' }}>
                      <Tooltip title="This product is not active in selected Business Unit">
                        <InfoCircleOutlined
                          style={{
                            color: '#1677ff',
                            cursor: 'pointer',
                            fontSize: '14px',
                          }}
                        />
                      </Tooltip>
                    </div>
                  ) : ''}
                </div>
              </React.Fragment>

              {record?.product_category_info?.category_path?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={record?.product_category_info?.category_path}
                  categoryName={record?.product_category_info?.category_path?.at(-1)}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
            </div>
          );
        },
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'Current Stock',
        width: '120px',
        dataIndex: 'quantity',
        render: (text, record) => `${QUANTITY(
          ((record?.currentStock * record?.product_info?.uom_info?.ratio) / (record?.uomInfo?.ratio || record?.uom_info?.ratio)) || '0',
          record?.uomInfo?.precision,
        )} ${record?.uomInfo?.uqc?.toProperCase() || record?.uom_info?.uqc?.toProperCase() || ''}`,
        visible: visibleColumns?.CURRENT_STOCK?.visible,
      },
      {
        title: 'Estimated Usage',
        width: '173px',
        render: (text, record) => {
          const {
            createMOLoading,
            updateMOLoading,
            formSubmitted,
            handleQuantityChange,
            multipleFG,
          } = props;
          return (
            <React.Fragment>
              <div className="mo-rm-table__quantity">
                <H3FormInput
                  name="a valid quantity"
                  type="number"
                  containerClassName={`orgInputContainer mo-form__input-row__input ${formSubmitted && (!record?.estimatedUsage || Number(record?.estimatedUsage) <= 0) ? 'form-error__input' : ''}`}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  placeholder=""
                  onChange={(e) => {
                    CustomFieldHelpers.updateCustomColumnValue(Number(e.target.value || 0), record?.lineCustomFields?.find((i) => i?.fieldName === 'Quantity'), record?.lineCustomFields, (value) => customLineInputChange(value, record?.key, record?.fg_tenant_product_id));
                  }}
                  value={record?.estimatedUsage}
                  showError={formSubmitted && (!record?.estimatedUsage || Number(record?.estimatedUsage) === 0)}
                  disabled={createMOLoading || updateMOLoading || (record?.product_sku_id && !record?.tenant_product_info?.tenant_product_id)}
                  loading={createMOLoading || updateMOLoading}
                />
              </div>
            </React.Fragment>
          );
        },
        visible: visibleColumns?.ESTIMATED_USAGE?.visible,
      },
    ];
    if (trackWastage) {
      columns.push({
        title: 'Estimated Overage', // -> Estimated Wastage
        width: '173px',
        render: (text, record) => {
          const {
            createMOLoading,
            updateMOLoading,
            formSubmitted,
            handleQuantityChange,
            multipleFG,
          } = props;
          return (
            <div>
              <div className="mo-rm-table__quantity">
                <H3FormInput
                  name="a valid quantity"
                  type="number"
                  containerClassName={formSubmitted && (Number(record?.wastage_quantity) < 0) ? 'form-error__input' : 'orgInputContainer mo-form__input-row__input'}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  placeholder=""
                  onChange={(e) => {
                    handleQuantityChange(record?.fg_tenant_product_id, record?.estimatedUsage, record?.key, e.target.value);
                  }}
                  value={record?.wastage_quantity}
                  disabled={createMOLoading || updateMOLoading || (record?.product_sku_id && !record?.tenant_product_info?.tenant_product_id)}
                  loading={createMOLoading || updateMOLoading}
                />
              </div>
              <div className="table-subscript" style={{ marginTop: '4px' }}>
                {/* {`${record?.wastage_percentage || '0'}% as per Bill of Material`} */}
                {!record?.isAdhocLine ? `${record?.wastage_percentage || '0'}% as per Bill of Material` : ''}
              </div>
            </div>
          );
        },
        visible: visibleColumns?.ESTIMATED_WASTAGE?.visible,
      });
    }
    columns.push(
      {
        title: 'Unit Cost',
        render: (text, record) => ((isDataMaskingPolicyEnable & isHideCostPrice) ? <HideValue showPopOver popOverMessage="You don't have access to view unit cost" /> : `${props.MONEY(record?.costPerUnit || 0)}`),
        visible: visibleColumns?.UNIT_COST?.visible,
        onCell: (item) => {
          if (!item?.parent_bom_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: 'Unit',
        width: '110px',
        visible: false,
        render: (text, record) => (
          <div style={{ width: '100px' }}>
            <PRZSelect
              filterOption={false}
              className=""
              value={record?.uomId}
              onChange={(value) => {
                const copyData = JSON.parse(JSON.stringify(bomLinesArray));
                let newUomInfo = {};
                copyData.map((item) => {
                  const uomList = item?.uom_list || item?.product_info?.uom_list;
                  if (item.bom_line_id === record.bom_line_id) {
                    item.uomId = value;
                    item.uomInfo = uomList?.find((rec) => rec?.uom_id === value);
                    newUomInfo = uomList?.find((rec) => rec?.uom_id === value);
                    updateData(copyData, item?.fg_tenant_product_id, item?.bom_line_id);
                  }
                });
              }}
              disabled
            >
              {
                record?.product_info?.uom_list?.map((uom) => (
                  <Select.Option key={uom?.uom_id} value={uom?.uom_id}>{`${uom?.uqc?.toProperCase()} (${uom?.uom_name?.toProperCase()})`}</Select.Option>
                ))
              }
            </PRZSelect>
          </div>
        ),
      },
      {
        title: ' ',
        width: '40px',
        fixed: 'right',
        render: (text, record) => {
          const { handleDelete } = props;
          return (
            <div style={{ pointerEvents: 'all' }}>
              <Popconfirm
                title="Confirm remove Raw material?"
                onConfirm={() => handleDelete(record?.product_sku_id, record?.key, record)}
                onCancel={() => { }}
                okText="Yes"
                cancelText="No"
                placement="topLeft"
              >
                <div className="mp-fg__delete-line-button">
                  <CloseOutlined />
                </div>
              </Popconfirm>
            </div>
          );
        },
        visible: true,
      },
    );
    if (cfRMLine?.length) {
      columns.splice(5, 0, ...CustomFieldHelpers.renderCustomLineColumns(null, cfRMLine, visibleColumns, customLineInputChange, formSubmitted));
    }
    return columns?.filter((item) => item?.visible);
  };

  const getDataSource = () => {
    if (data) {
      const copyData = JSON.parse(JSON.stringify(data));
      let sqnNumber = 1;
      for (let i = 0; i < copyData?.length; i++) {
        if (copyData[i]?.parent_bom_id) {
          copyData[i] = { ...copyData[i], sqn: sqnNumber };
          sqnNumber++;
        }
      }
      return copyData;
    }
    return [];
  };

  const getDataByEmptyRowAtLast = (lines) => [...lines.filter((item) => item?.tenant_product_info?.product_sku_id), ...lines.filter((item) => !item?.tenant_product_info?.product_sku_id)];
  const getDataSourceForEachFG = (fgTenantProductId) => getDataByEmptyRowAtLast(bomLines[fgTenantProductId]);

  function renderChildBomTable(childBomLines, record) {
    return (
      <Table
        className="custom-table"
        showHeader
        size="small"
        scroll={{ x: 'max-content' }}
        columns={getColumns(true)}
        dataSource={childBomLines
          ?.map((item) => (bomLinesArray.find((bomLine) => {
            if (bomLine?.bom_line_id === item?.bom_line_id) return Object.assign(bomLine, { parentSqn: item?.parentSqn });
          })))?.map((line, index) => ({ ...line, sqn: index + 1 }))}
        pagination={false}
        bordered
        expandable={{
          rowExpandable: (rec) => rec?.child_bom_lines?.filter((line) => bomLinesArray.some((bomLine) => bomLine?.bom_line_id === line?.bom_line_id)).length > 0,
          expandedRowRender: (rec) => renderChildBomTable(getDataByEmptyRowAtLast(rec?.child_bom_lines)?.map((item) => ({ ...item, parentSqn: `${rec?.parentSqn ? `${rec?.parentSqn}.` : ''}${rec?.sqn}` })), rec),
          expandedRowKeys,
          onExpandedRowsChange: (expandedRows) => {
            setExpandedRowKeys(expandedRows);
          },
        }}
        footer={() => (
          <span className="child-footer">
            {`--- ${record?.tenant_product_info?.alias_name || record?.tenant_product_info?.product_sku_name} RM end ---`}
          </span>
        )}
      />
    );
  }

  return (
    <Fragment>
      {finishedGoods?.map((fg) => (
        fg?.tenant_product_info?.tenant_product_id ? (
          <div className="mo-new-rm__wrapper" key={fg.key || uuidv4()}>
            <div className="table__fg">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{
                  display: 'inline-block', fontSize: '13px', fontWeight: 500, marginLeft: '10px',
                }}
                >
                  {fg?.tenant_product_info?.alias_name}
                  {' '}
                  <CaretRightFilled />
                </span>
                <PRZButton
                  className={disableAddNewRMButton ? 'disable-add-rm-button' : ''}
                  buttonStyle={{ borderRadius: '4px', width: 'fit-content' }}
                  type="ghost"
                  size="small"
                  onClick={() => {
                    addNewRow({ parentData: fg });
                  }}
                  disabled={disableAddNewRMButton}
                >
                  <FontAwesomeIcon icon={faCirclePlus} color="#74C0FC" />
                  &nbsp;
                  <span style={{ fontSize: '11px' }}>Add RM</span>
                </PRZButton>
              </div>
            </div>
            {getDataSourceForEachFG(fg?.tenant_product_info?.tenant_product_id)?.filter((item) => !item?.isChildBom)?.length > 0 && (
              <div className="mo-rm-table__wrapper">
                <Table
                  bordered
                  loading={loading}
                  showHeader
                  size="small"
                  scroll={{ x: 'max-content' }}
                  columns={getColumns(false)}
                  dataSource={getDataSourceForEachFG(fg?.tenant_product_info?.tenant_product_id)?.filter((item) => !item?.isChildBom)?.map((line, index) => ({ ...line, sqn: index + 1 }))}
                  pagination={false}
                  expandable={{
                    rowExpandable: (rec) => rec?.child_bom_lines?.filter((line) => bomLinesArray.some((bomLine) => bomLine?.bom_line_id === line?.bom_line_id))?.length > 0,
                    expandedRowRender: (rec) => renderChildBomTable(getDataByEmptyRowAtLast(rec?.child_bom_lines)?.map((item) => ({ ...item, parentSqn: `${rec?.parentSqn ? `${rec?.parentSqn}.` : ''}${rec?.sqn}` })), rec),
                    expandedRowKeys,
                    onExpandedRowsChange: (expandedRows) => {
                      setExpandedRowKeys(expandedRows);
                    },
                  }}
                  rowClassName={(record) => (record?.product_sku_id && !record.tenant_product_info?.tenant_product_id ? 'disabled-mo-rw-table-row' : '')}
                />
              </div>
            )}
          </div>
        ) : null
      ))}
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewRawMaterial));
